const state = {
  plainproductTypes: [],
  productTypes: [],
  productType: {},
  getProductTypeLoading: false
};

export default {
  namespaced: true,
  state,
  mutations: {
    setProductTypes(state, productTypes) {
      state.productTypes = productTypes;
    },
    setPlainProductTypes(state, productTypes) {
      state.plainproductTypes = productTypes;
    },
    setProductType(state, productType) {
      state.productType = productType;
    },
    setGetProductTypeLoading(state, loading) {
      state.getProductTypeLoading = loading;
    }
  },
  actions: {
    fetchProductTypes({ commit }, payload) {
      const { dontPaginate, filter, page, paginationcount } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/type', {
              params: { page: payload.page, filter: filter, paginationcount: paginationcount }
            })
            .then(response => {
              commit('setProductTypes', response.data);
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .finally(() => {
              commit('SET_LOADING', false, { root: true });
            });
        }
        return axios
          .get('api/v1/type', { params: { page: payload.page, paginationcount: paginationcount } })
          .then(response => {
            commit('setProductTypes', response.data);
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => {
            commit('SET_LOADING', false, { root: true });
          });
      } else {
        return axios.get('api/v1/type', { params: { paginate: 0 } }).then(response => {
          commit('setPlainProductTypes', response.data);
        });
      }
    },
    getProductType({ commit }, payload) {
      commit('setGetProductTypeLoading', true);
      return axios
        .get(`api/v1/type/${payload.id}`)
        .then(response => {
          commit('setProductType', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setProductType', {});
          }
        })
        .finally(() => {
          commit('setGetProductTypeLoading', false);
        });
    }
  }
};
